module.exports = __webpack_public_path__ + "static/media/menu.5a793aed.svg";